<template>
  <div class="card">
    <div class="card-body">
      Content here (list, show, new, edit)
    </div>
  </div>
</template>
